import React from 'react';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';

interface WhenFieldChangesProps {
  field: string;
  set: string;
  to: any;
}
export const WhenFieldChanges: React.FC<WhenFieldChangesProps> = ({ field, set, to }) => (
  <Field name={set} subscription={{}}>
    {({ input: { onChange } }) => (
      <OnChange name={field}>
        {() => {
          onChange(to);
        }}
      </OnChange>
    )}
  </Field>
);
